import { getBnySatGraphBaseUrl } from '../../services/apiService';
import { apiCall, createApiThunk, graphqlCall } from '../../utils/api';
import {
  getAllBasketsQuery,
  getBasketWithIdQuery,
  getClientsAndFundsQuery,
  getDeleteBasketQuery,
  getDeleteSecurityQuery,
  getHoldInventoryDataQuery,
  getInventoryDataQuery,
  getSaveBasketQuery,
} from './SwapBasketsQueries';
import { setBasketInputData } from './SwapBasketsSlice';
import { print } from 'graphql';

export const getInventoryDataThunk = createApiThunk('GET_INVENTORY_DATA', apiCall);
export const holdInventoryDataThunk = createApiThunk('HOLD_INVENTORY_DATA', apiCall);
export const basketWithIdThunk = createApiThunk('SELECTED_BASKET_DATA', graphqlCall);
export const deleteSecurityThunk = createApiThunk('DELETE_SECURITY', apiCall);
export const cancelFullBasketThunk = createApiThunk('CANCEL_FULL_BASKET', apiCall);
export const saveBasketThunk = createApiThunk('SAVE_BASKET', apiCall);
export const getAllBasketsThunk = createApiThunk('GET_ALL_BASKETS', graphqlCall);
export const getClientsAndFundsThunk = createApiThunk('GET_CLIENTS_FUNDS', graphqlCall);

export const getInventoryData = (data: any) => (dispatch: AppDispatch) => {
  const url = getInventoryDataQuery();
  const method = 'POST';
  dispatch(setBasketInputData(data));
  return dispatch(getInventoryDataThunk({ url, data, method }));
};

export const holdInventoryData =
  (data: any, fromSubstitution?: boolean) => (dispatch: AppDispatch) => {
    const url = getHoldInventoryDataQuery(fromSubstitution);
    const method = 'POST';
    return dispatch(
      holdInventoryDataThunk({ url, data, method, params: { fromSubstitution: fromSubstitution } }),
    );
  };

export const deleteSecurity =
  (basketId: string, version: number, securityId: number) => (dispatch: AppDispatch) => {
    const url = getDeleteSecurityQuery(basketId, version, securityId);
    const method = 'DELETE';
    return dispatch(deleteSecurityThunk({ url, method, securityId } as any));
  };

export const cancelFullBasket = (basketId: string, version: number) => (dispatch: AppDispatch) => {
  const url = getDeleteBasketQuery(basketId, version);
  const method = 'POST';
  return dispatch(cancelFullBasketThunk({ url, method }));
};

export const saveBasket =
  (basketId: string, version: number, fromOrderEntry: boolean, data: any) =>
  (dispatch: AppDispatch) => {
    const url = getSaveBasketQuery(basketId, version, fromOrderEntry);
    const method = 'PUT';
    return dispatch(saveBasketThunk({ url, method, data }));
  };

export const getAllBaskets = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getAllBasketsQuery());
  dispatch(getAllBasketsThunk({ url, query }));
};

export const getClientsAndFunds = () => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getClientsAndFundsQuery());
  return dispatch(getClientsAndFundsThunk({ url, query }));
};

export const getBasketWithId = (basketId: string, version: number) => (dispatch: AppDispatch) => {
  const url = getBnySatGraphBaseUrl();
  const query = print(getBasketWithIdQuery(basketId, version));
  return dispatch(basketWithIdThunk({ url, query }));
};
